import { SettingsSelect } from './SettingsSelect';
export default SettingsSelect;
